import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Integrations14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_121)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.43942 3.50002L6.4394 4.5L5.46973 5.46967L6.53039 6.53033L7.50006 5.56066L8.4394 6.5L7.46973 7.46967L8.53039 8.53033L9.50006 7.56066L10.5001 8.56068L13.1769 5.8839C13.665 5.39575 13.665 4.60429 13.1769 4.11613L12.0607 2.99995L13.5303 1.53034L12.4696 0.469683L11 1.93929L9.88396 0.823239C9.39581 0.335085 8.60435 0.335083 8.11619 0.823239L5.43942 3.50002ZM9.00008 2.06068L11.9394 5.00002L10.5001 6.43936L7.56074 3.50002L9.00008 2.06068Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.56059 10.5L3.49992 5.43934L0.823148 8.11612C0.334993 8.60427 0.334992 9.39573 0.823148 9.88388L1.93933 11.0001L0.469727 12.4697L1.53039 13.5303L2.99999 12.0607L4.11604 13.1768C4.6042 13.6649 5.39565 13.6649 5.88381 13.1768L8.56059 10.5ZM4.99992 11.9393L2.06058 9L3.49992 7.56066L6.43926 10.5L4.99992 11.9393Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_121'>
        <rect width='14' height='14' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Integrations14.displayName = 'Integrations14';
export default Integrations14;
